<template>
<transition name="fade-in">
    <div class="edit-profile-wrapper">
      <div class="user-info">

        <styled-input-layout key-index="profile-password-field"
                             title="새 비밀번호 입력"
                             :value="password"
                             type="password"
                             @input="updatePassword"
                             :callback="enterEvent"
                             regex="^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$"/>

        <styled-input-layout key-index="profile-password-confirm-field"
                             title="비밀번호 확인"
                             :value="confirmPassword"
                             type="password"
                             @input="updateConfirmPassword"
                             :callback="enterEvent"
                             regex="^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$"/>

      </div>

      <div class="button-group">
        <slot></slot>
      </div>
    </div>
</transition>
</template>

<script>
import StyledInputLayout from '@/spa/components/LayoutStyledInput';

export default {
  name: 'ResetPassword',
  components: {
    StyledInputLayout,
  },
  props: {
    password: String,
    confirmPassword: String,
    enterEvent: Function,
  },
  methods: {
    updatePassword(value) {
      this.$emit('password', value);
    },
    updateConfirmPassword(value) {
      this.$emit('confirmPassword', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-profile-wrapper {
  position: absolute;
  width: 100%;

  .user-info {
    margin-top: 12px;

    div {
      font-size: 16px;
      margin-bottom: 6px;

      &.name {
        font-size: 20px;
        margin-bottom: 12px;
      }

      &.phone, &.email {
        color: $nd60;
      }
    }
  }

  .button-group {
    margin-top: 24px;

    button {
      font-size: 16px;
      padding: 14px 24px;
      border-radius: 4px;
      border: 1px solid $color_active_blue;

      &.edit-profile {
        color: $color_active_blue;
        background-color: transparent;
        margin-right: 16px;
      }

      &.reset-password {
        color: $color_white;
        background-color: $color_active_blue;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/profile/layouts/ResetPassword.vue